import { getImageUrl } from './getImageUrl';

export const showLoading = () => {
  const container = document.createElement('div');
  container.id = 'loadingContainer';
  container.style.position = 'fixed';
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = '100vw';
  container.style.height = '100vh';
  container.style.display = 'flex';
  container.style.justifyContent = 'center';
  container.style.alignItems = 'center';
  container.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
  container.style.zIndex = '1000000';

  const loader = document.createElement('div');
  loader.className = 'loader';
  loader.style.width = '60px';
  loader.style.height = '60px';
  loader.style.animation = 'spin 4s linear infinite';

  const loadingImg = document.createElement('img');
  loadingImg.src = getImageUrl('ans_loading.png');
  loadingImg.style.width = '100%';
  loadingImg.style.height = '100%';

  loader.appendChild(loadingImg);
  container.appendChild(loader);
  document.body.appendChild(container);

  const keyframes = document.createElement('style');
  keyframes.textContent = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            20% { transform: rotate(80deg); }
            25% { transform: rotate(90deg); }
            30% { transform: rotate(100deg); }
            45% { transform: rotate(170deg); }
            50% { transform: rotate(180deg); }
            70% { transform: rotate(260deg); }
            75% { transform: rotate(270deg); }
            80% { transform: rotate(280deg); }
            95% { transform: rotate(350deg); }
            100% { transform: rotate(360deg); }
        }
    `;
  document.head.appendChild(keyframes);
};

export const hideLoading = () => {
  const container = document.getElementById('loadingContainer');
  if (container) {
    document.body.removeChild(container);
  }
};
